<div class="results-page">
    <div class="results-page__title">
        <h2>{{title}}</h2>
    </div>
    <div class="results-page__content">
        <app-results-list
            [nit]="nit"
            [numDocumento]="numDocumento"
            [numeroNit]="numeroNit"
            [name]="name"
            [declara]="declara"
            [plazo]="plazo"
            [conditions]="conditions"
            (onError)="handleChildError()">
        </app-results-list>
    </div>
</div>
